<template>
   <v-app>
      <v-main>
         <v-container fluid fill-height>
            <v-layout align-center justify-center>
               <v-flex xs12 sm8 md4>
                  <v-card class="elevation-12">
                     <v-toolbar dark color="primary">
                        <v-toolbar-title>{{isRegister ? stateObj.register.name : stateObj.login.name}} form</v-toolbar-title>
                     </v-toolbar>
                     <v-card-text>
                     <form ref="form" @submit.prevent="isRegister ? register() : login()">
                            <v-text-field
                              v-model="username"
                              name="username"
                              label="Username"
                              type="text"
                              placeholder="username"
                              required
                           ></v-text-field>
                           
                            <v-text-field
                              v-model="password"
                              name="password"
                              label="Password"
                              type="password"
                              placeholder="password"
                              required
                           ></v-text-field>

                           <v-text-field v-if="isRegister"
                              v-model="confirmPassword"
                              name="confirmPassword"
                              label="Confirm Password"
                              type="password"
                              placeholder="cocnfirm password"
                              required
                           ></v-text-field>
                           <div class="red--text"> {{errorMessage}}</div>
                           
                           <v-btn type="submit" class="mt-4" color="primary" value="log in">{{isRegister ? stateObj.register.name : stateObj.login.name}}</v-btn>
                           
                           <!-- <div class="grey--text mt-4" v-on:click="isRegister = !isRegister;">
                              {{toggleMessage}}  
                           </div> -->
                           <!-- <div class="grey--text mt-4">
                              {{loginErrorMessage}}  
                           </div> -->
                      </form>
                     </v-card-text>
                  </v-card>
                
               </v-flex>
            </v-layout>
         </v-container>
      </v-main>
   </v-app>
</template>

<script>
export default {
  name: "Login",
  data() {
    return {
      username: "",
      password: "",
      confirmPassword: "",
      isRegister : false,
      errorMessage: "",
      // login_state: false,
      stateObj: {
         register :{
            name: 'Register',
            message: 'Aleady have an Acoount? login.'
         },
         login : {
            name: 'Login',
            message: 'Register'
         }
      }
    };
  },
  watch: {
    login_state() {
      // this.login_state = this.$store.state.login_state;
      if (this.login_state) {
        this.$router.replace({ name: "dashboard"});
      }
    },
   // errorMessage() {
      // this.errorMessage = this.$store.state.login_error;
   // }
  },
  methods: {
      login() {
         const { username, password } = this;
         const past_login_state = this.login_state;
         // check only if not logged in
         // if (!past_login_state) {
         this.$store.dispatch("login", { username, password });
         // }
         console.log(this.$store.state.login_state, "login state");
         this.login_state = this.$store.state.login_state;
         console.log(this.login_state, "login state", past_login_state, "past login state");
         if (this.login_state) {
            // this.$router.replace({ name: "dashboard", params: { username: username } });
            this.$router.replace({ name: "dashboard"});

         } else {
            this.errorMessage = this.$store.state.login_error;
         }
      
      //   .then(() => {
      //     this.$router.replace({ name: "dashboard", params: { username: username } });
      //   })
      //   .catch((error) => {
      //     this.errorMessage = error.message;
      //   });
      // this.$router.replace({ name: "dashboard", params: { username: username } });
    },
    register() {
       if(this.password == this.confirmPassword){
          this.isRegister = false;
          this.errorMessage = "";
          this.$refs.form.reset();
       }
       else {
         this.errorMessage = "password did not match"
       }
    },

  },
   computed: {
      toggleMessage : function() { 
         return this.isRegister ? this.stateObj.register.message : this.stateObj.login.message
      },
      login_state: function() { 
      // this.$store.dispatch("login", { this.username, this.password });
         return this.$store.state.login_state;
      },
      // errorMessage: function() { 
      //    return this.$store.state.login_error;
      // },
   },
   mounted() { 
      this.login() 
      // this.errorMessage = this.$store.state.login_error;
   }
};
</script>